
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Home_V2 from "../pages/v2/home/page";
import Schedule from "../pages/schedule/page";
import Classes from "../pages/classes/page";
import Aerial from "../pages/aerial/page";
import Values from "../pages/values/page";
import FarInfraredHeat from "../pages/far-infrared-heat/page";
import Immersive from "../pages/immersive/page";
import Studio from "../pages/studio/page";
import MembershipPage from '../pages/membership/page';
import EventsPage from '../pages/events/page';
import EventsChildrenPage from '../pages/events-children/page';
import EventsAdultsPage from '../pages/events-adults/page';
import Presale from '../pages/presale/page';
import Landing from '../pages/landing/page';
import { lazy } from "react";
import Account from "../pages/account/page";
import Register from "../pages/register/page";
import ScheduleMT from "../pages/ScheduleMT/page";
import Pricing from "../pages/pricing/page";
import Terms from "../pages/terms-conditions/page";
import Waiver from "../pages/waiver/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Maintenance from "../pages/maintenance/page";
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/home_v2",
    element: <Home_V2 />,
  },
  {
    path: "/schedule",
    element: <Schedule />,
  },
  {
    path: "/classes",
    element: <Classes />,
  },
  {
    path: "/aerial",
    element: <Aerial />,
  },
  {
    path: "/our-values-&-ethics",
    element: <Values />,
  },
  {
    path: "/far-infrared-heat",
    element: <FarInfraredHeat />,
  },
  {
    path: "/immersive",
    element: <Immersive />,
  },
  {
    path: "/studio",
    element: <Studio />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    // Grand Opening ended 2026-06-21 -> forward to the $37 2-Week Unlimited intro.
    path: "/grandopening",
    element: <Navigate to="/buy-now?_mt=%2Fbuy%2F48717%3FactiveProduct%3Dmemberships-14775" replace />,
  },
  {
    path: "/events-children",
    element: <EventsChildrenPage />,
  },
  {
    path: "/events-adults",
    element: <EventsAdultsPage />,
  },
  {
    path: "/presale",
    element: <Home />,
  },
  {
    path: "/landing",
    element: <Landing />,
  },
  {
    path: "/account",
    element: <Account />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/book-now",
    element: <ScheduleMT />,
  },
  {
    path: "/buy-now",
    element: <Pricing />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/waiver",
    element: <Waiver />,
  },
  {
    path: "/maintenance",
    element: <Maintenance />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
